
export default function ContactInfoSection() {
  return null;
}